import { assert, error, log } from '../../../app/logger.js';
import { EventedLeaflet } from './evented_leaflet.js';

/**
 * Leaflet layer.
 */
class LayerLeaflet extends EventedLeaflet {
  constructor(options) {
    super(options);

    log(`[map:leaflet] '${this.name}' ${this.type} created`);
    const { map } = options;
    assert(map, `[map:leaflet] set map for '${this.name}': no map`);
    assert(
      map.native,
      `[map:leaflet] set map for '${this.name}': no leaflet map`
    );
    this.#nativeMap = map.native;

    if (options.visible) {
      this.attachTo();
    }
  }

  get clickable() {
    return this.options.clickable;
  }

  get draggable() {
    return this.options.draggable;
  }

  set draggable(v) {
    this.options.draggable = v;
    // TODO: does it work? Leaflet API doesn't seem have draggable property.
    if (this.native) {
      this.native.draggable = v;
    }
  }

  get visible() {
    return this.attached;
  }

  set visible(v) {
    if (v != this.visible) {
      v ? this.attachTo() : this.deattach();
    }
  }

  setStyles(options) {
    for (let option in options) {
      this.options[option] = options[option];
    }
    if (this.native) {
      this.native.setStyle(this.getNativeOptions(options));
    }
  }

  get attached() {
    return !!this.#attached;
  }

  attachTo() {
    if (this.#attached) {
      return;
    }

    log(`[map:leaflet] attach '${this.name}' to the map`);
    if (!this.native) {
      this.initialize();
    }
    this.native.addTo(this.#nativeMap);
    this.#attached = true;
  }

  deattach() {
    if (!this.#attached) {
      return;
    }

    log(`[map:leaflet] deattach '${this.name}' from the map`);
    assert(this.native, `[map:leaflet] '${this.name}' has no native object`);
    assert(
      this.#nativeMap,
      `[map:leaflet] '${this.name}' has no associated native map`
    );
    this.native.remove(this.#nativeMap);
    this.#attached = false;
  }

  // Protected

  get nativeMap() {
    return this.#nativeMap;
  }

  createNative() {
    error(`[map] createNative must be overriden`);
    return null;
  }

  static nativeOptionsMapper = {
    clickable: 'interactive',
    draggable: 'draggable',
  };

  #attached;
  #nativeMap;
}

export { LayerLeaflet };
